
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { BModal } from 'bootstrap-vue';

@Component
export default class StandardPhraseModal extends Vue {
  @Action displayError!: (s: string) => void;
  @Action displaySuccess!: (s: string) => void;

  id: string | null = null;

  submitting = false;
  submitted = false;

  form: {
    text: string;
  } = {
    text: '',
  };

  $refs!: {
    modal: BModal;
  };

  async show(id?: string) {
    this.submitted = false;
    this.form.text = '';
    this.id = id || null;

    if (id) {
      try {
        const response = await this.$placementApi.standardPhraseRetrieve({
          uuid: id,
        });

        this.form.text = response.data.text;
      } catch (e) {
        this.$log.debug(e);
        this.displayError(`Óvænt villa kom upp. Vinsamlegast reyndu aftur.`);
      }
    }

    this.$refs.modal.show();
  }

  async validateBeforeSubmit() {
    try {
      this.submitted = true;
      await this.$validator.validateAll().then(response => {
        if (!response) throw 'FormValidationError'; // eslint-disable-line no-throw-literal
      });

      try {
        this.submitting = true;

        if (this.id) {
          await this.$placementApi.standardPhraseUpdate({
            uuid: this.id,
            standardPhraseDetailUpdateRequest: {
              text: this.form.text,
            },
          });

          this.displaySuccess(`Staðlaður texti hefur verið uppfærður.`);
        } else {
          await this.$placementApi.standardPhraseCreate({
            standardPhraseDetailRequest: {
              text: this.form.text,
            },
          });

          this.displaySuccess(`Staðlaður texti hefur verið stofnaður.`);
        }

        this.submitted = false;
        this.$emit('successful', {});
        this.$refs.modal.hide();
      } catch (e) {
        this.$log.debug(e);
        this.displayError(`Óvænt villa kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.submitting = false;
      }
    } catch (e) {
      this.$log.debug(e);
    }
  }
}
